module.exports = __webpack_public_path__ + "static/media/building.895d20c4.png";